import { Spinner } from "../../../components/Spinner";
import {
  useAgregarEspecialistaMutation,
  useBuscarEspecialistaMutation,
  useGetEspecialistasQuery,
  useLazyGetEspecialistasQuery,
  useRmEspecialistaMutation,
} from "../../../services/docs";
import { useForm } from "../../../hooks/useForm";
import { useNavigate } from "react-router-dom";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import { toastr } from "react-redux-toastr";

import {
  Search,
  Filter,
  UserPlus,
  Coffee,
  UserMinus,
  Users,
  CheckCircle,
  FileText,
  Check,
} from "lucide-react";
import { useEffect, useState } from "react";

export const AgregarEspecialistaScreen = () => {
  const [ListEspecialista, setListEspecialista] = useState([]);
  const { data, isLoading: isLoadingEspecialistas } =
    useGetEspecialistasQuery();
  useEffect(() => {
    if (data) {
      if (data.especialistas) {
        setListEspecialista(data.especialistas);
      }
    }
  }, [data]);
  const { formulario, handleInputChange, handleSelectChange } = useForm({
    fc_busqueda: "",
    fc_valor: "",
  });

  const [buscarEjecutivoAction, { data: especialista, isLoading, error }] =
    useBuscarEspecialistaMutation();
  const [rmEspecialistaAction, { isLoading: isLCambio }] =
    useRmEspecialistaMutation();

  const buscarEjecutivos = async () => {
    if (formulario.fc_busqueda.trim() === "") {
      toastr.error("Debe seleccionar un tipo de búsqueda");
      return;
    }
    if (formulario.fc_valor === "") {
      toastr.error("Debes de agregar un valor de busqueda");
      return;
    }
    const ejecutivo = await buscarEjecutivoAction({
      ...formulario,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 404) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
      });
    if (ejecutivo) {
      setListEspecialista(ejecutivo.ejecutivos);
    }
  };
  const CambiarDescanso = async (e) => {
    if (!e) {
      toastr.error("Debe seleccionar un Especialista");
      return;
    }
    let descanso = +e.fi_descanso === 1 ? 0 : 1;
    const resp = await rmEspecialistaAction({
      fi_usuario_id: e.sub,
      fi_descanso: descanso,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 404) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
      });
    if (resp.message) {
      toastr.info(resp.message);
    }
  };
  const rmEspecialista = async (e) => {
    if (!e) {
      toastr.error("Debe seleccionar un Especialista");
      return;
    }
    const resp = await rmEspecialistaAction({
      fi_usuario_id: e.sub,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 404) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
      });
    if (resp.message) {
      toastr.info(resp.message);
    }
  };

  const pEspecialista = async (id, prioridad) => {
    if (!id) {
      toastr.error("Debe seleccionar un Especialista");
      return;
    }
    const resp = await rmEspecialistaAction({
      fi_usuario_id: id,
      fi_prioridad: prioridad,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 404) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
      });
    if (resp.message) {
      toastr.info(resp.message);
    }
  };
  return (
    <>
      <header className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">
            Administración de Equipo
          </h1>
          <p className="text-slate-500">
            Gestiona el desempeño y disponibilidad de tu equipo.
          </p>
        </div>
      </header>
      <div className="mb-6 flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="relative flex-1">
          <Search
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            size={18}
          />
          <input
            type="text"
            placeholder="Buscar por correo electronico"
            name="fc_valor"
            onChange={handleInputChange}
            className="w-full rounded-lg border-none bg-slate-100 py-2 pl-10 pr-4 outline-none transition focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <select
          name="fc_busqueda"
          onChange={handleSelectChange}
          className="cursor-pointer rounded-lg border-none bg-slate-100 px-4 py-2 text-sm font-medium text-slate-600"
        >
          <option value="">Selecciona</option>
          <option value="email">Correo electronico</option>
        </select>
        <div className="flex items-center gap-2 rounded-lg px-4 py-2 font-semibold text-blue-600 transition hover:bg-blue-50">
          {!isLoading && (
            <Button onClick={buscarEjecutivos}>Buscar Especialista</Button>
          )}
          {isLoading && <Spinner />}
        </div>
      </div>
      <div className="mb-8 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full border-collapse text-left">
          <thead className="border-b border-slate-200 bg-slate-50">
            <tr>
              <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500">
                Nombre
              </th>
              <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500">
                Correo
              </th>
              <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500">
                Estado
              </th>
              <th className="px-6 py-4 text-center text-xs font-bold uppercase tracking-wider text-slate-500">
                Siniestros
              </th>
              <th className="px-2 py-4 text-xs font-bold uppercase tracking-wider text-slate-500">
                Prioridad
              </th>
              <th className="px-6 py-4 text-right text-xs font-bold uppercase tracking-wider text-slate-500">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {ListEspecialista.length > 0 &&
              ListEspecialista.map((eje) => (
                <tr key={eje.id} className="group transition hover:bg-slate-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-200 font-bold text-slate-500">
                        <img src={eje.fc_avatar} />
                      </div>
                      <div>
                        <div className="font-bold text-slate-900">
                          {eje.fc_name}
                        </div>
                        <div className="text-xs text-slate-500">
                          ID: {eje.sub}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">
                    {eje.fc_email}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${
                        eje.fi_descanso === 0
                          ? "bg-green-100 text-green-700"
                          : "bg-orange-100 text-orange-700"
                      }`}
                    >
                      <span
                        className={`h-1.5 w-1.5 rounded-full ${
                          eje.fi_descanso === 0
                            ? "bg-green-500"
                            : "bg-orange-500"
                        }`}
                      />
                      {eje.fi_descanso === 0 ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center font-bold text-slate-700">
                    {eje.total_siniestros}
                  </td>
                  <td className=" px-2 py-4 text-center font-bold text-slate-700">
                    <select
                      name="fi_prioridad"
                      onChange={(e) => pEspecialista(eje.sub, +e.target.value)}
                      className="cursor-pointer rounded-lg border-none bg-slate-100  py-2 text-sm font-medium text-slate-600"
                      defaultValue={eje.fi_prioridad?.toString()}
                    >
                      <option value="0">Selecciona {eje.fi_prioridad}</option>
                      <option value="3">Muy Alta</option>
                      <option value="2">Alta</option>
                      <option value="1">Baja</option>
                    </select>
                  </td>
                  <td className="flex justify-end gap-2 px-6 py-4 opacity-0 transition-opacity group-hover:opacity-100">
                    <button
                      onClick={() => CambiarDescanso(eje)}
                      className="flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:bg-slate-100"
                    >
                      {eje.fi_descanso === 1 && (
                        <>
                          <Check size={14} /> Despertar
                        </>
                      )}
                      {eje.fi_descanso === 0 && (
                        <>
                          <Coffee size={14} /> Descanso
                        </>
                      )}
                    </button>
                    <button
                      onClick={() => rmEspecialista(eje)}
                      className="flex items-center gap-1 rounded-lg border border-red-100 px-3 py-1.5 text-xs font-medium text-red-600 transition hover:bg-red-50"
                    >
                      {eje.fi_asignacion === 1 && (
                        <>
                          <UserMinus size={14} /> Quitar del equipo
                        </>
                      )}
                      {eje.fi_asignacion === 0 && (
                        <>
                          <UserMinus size={14} /> Agregar al equipo
                        </>
                      )}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
